import ExternalFactors from '../src/components/sections/ExternalFactors';

export default ExternalFactors;
